import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const addUserConfig = (userConfig: actionsInterfaces.IUserConfig, callback: IAsyncActionCallback): actionsInterfaces.IPostUserConfigAction => {
  return {
    type: actionsTypes.ADD_USERCONFIG,
    userConfig,
    callback
  };  
};

export const getUserConfig = (email:string, callback?: (result: any, error: any) => void): actionsInterfaces.IGetUserConfigAction => {
  return {
    type: actionsTypes.GET_USERCONFIG_INFO,
    email,
    callback
  };  
};

export const setUserConfig = (userConfig: actionsInterfaces.IUserConfig): actionsInterfaces.ISetUserConfigAction => {
  return {
    type: actionsTypes.SET_USERCONFIG_INFO,
    userConfig,
  };
};

export const addSuccess = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS,
    response,
  };
};

export const updateUserConfig = (userConfig: actionsInterfaces.IUserConfig, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateUserConfigAction => {
  return {
    type: actionsTypes.UPDATE_USERCONFIG,
    userConfig,
    callback
  };
};